import * as React from 'react';
interface Props {
  text: string,
}
const Toast: React.FC<Props> = props => (
  <p
    style={
      {
        position: 'fixed',
        zIndex: 999,
        padding: '10px 15px',
        borderRadius: '10px',
        opacity: '0.9',
        backgroundColor: 'black',
        fontSize: '16px',
        color: 'white',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      }
    }
  >
    {props.text}
  </p>
)

export default Toast;